import { ButtonContainer, InfoCard } from "@/components";
import type { VtexOrder } from "@/interfaces/vtex";
import { PagamentoContainer, PagamentoGrid } from "./style";
import { usePagamento } from "./usePagamento";

function getTotal(order: VtexOrder, id: string) {
  return order.totals.find((total) => total.id === id)?.value ?? 0;
}

export function Pagamento() {
  const { order } = usePagamento();

  if (!order) {
    return (
      <PagamentoContainer>
        <h3>Não há informações de pagamento disponíveis para este pedido.</h3>
      </PagamentoContainer>
    );
  }

  return (
    <PagamentoContainer>
      <PagamentoGrid>
        <InfoCard
          title="Total"
          labels={["Subtotal", "Desconto", "Frete", "Taxas", "Total"]}
          values={[
            `R$ ${getTotal(order, "Items") / 100}`,
            `R$ ${getTotal(order, "Discounts") / 100}`,
            `R$ ${getTotal(order, "Shipping") / 100}`,
            `R$ ${getTotal(order, "Tax") / 100}`,
            `R$ ${order.value / 100}`,
          ]}
        />
        <InfoCard
          title="Pagamento"
          labels={["Pagamento", "Valor", "Parcelas", "TID", "NSU"]}
          values={[
            order?.paymentData.transactions[0].payments[0].paymentSystemName ??
              "---",
            `R$ ${getTotal(order, "Items") / 100}`,
            order?.paymentData.transactions[0].payments[0].installments ??
              "---",
            order?.paymentData.transactions[0].payments[0].tid ?? "---",
            `${order?.paymentData.transactions[0].payments[0].connectorResponses?.nsu ?? "---"} `,
          ]}
        />
      </PagamentoGrid>
      <PagamentoGrid>
        <InfoCard
          title="Promoção"
          labels={order.ratesAndBenefitsData.rateAndBenefitsIdentifiers.map(
            (_, index: number) => `Promoção ${index + 1}`,
          )}
          values={order.ratesAndBenefitsData.rateAndBenefitsIdentifiers.map(
            (item) => item.name,
          )}
        />
        {/* <InfoCard
          title="Markenting"
          labels={["Marketing"]}
          values={[order?.marketingData?.marketingTags ?? "---"]}
        /> */}
      </PagamentoGrid>

      <ButtonContainer />
    </PagamentoContainer>
  );
}
